// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2e1Cd","label":"Labeled_label__nHURK","divider":"Labeled_divider__28e0r"};